import { isRadiusToken } from '@smoothie-framework/ui-core/tokens';
import { isCssWideKeyword } from './css-wide-keywords';
import { containsTokenReferenceSyntax, isBareUtilityIdentifier, isNumericUtilityLiteral, } from './utility-value-syntax';
function classifyNumericRadiusValue(normalizedValue) {
    const numericValue = Number(normalizedValue);
    if (!Number.isFinite(numericValue)) {
        return { valid: false, reason: 'invalid_type', normalizedValue };
    }
    if (numericValue < 0) {
        return { valid: false, reason: 'negative_not_allowed', normalizedValue };
    }
    return { valid: true, kind: 'numeric', normalizedValue };
}
export function classifyRadiusUtilityValue(rawValue) {
    if (rawValue === undefined || rawValue === null) {
        return { valid: false, reason: 'empty' };
    }
    if (typeof rawValue === 'number') {
        const normalizedValue = String(rawValue);
        return isNumericUtilityLiteral(normalizedValue)
            ? classifyNumericRadiusValue(normalizedValue)
            : { valid: false, reason: 'invalid_type', normalizedValue };
    }
    if (typeof rawValue !== 'string') {
        return { valid: false, reason: 'invalid_type' };
    }
    const normalizedValue = rawValue.trim();
    if (normalizedValue.length === 0) {
        return { valid: false, reason: 'empty' };
    }
    if (containsTokenReferenceSyntax(normalizedValue)) {
        return { valid: false, reason: 'token_reference', normalizedValue };
    }
    if (isRadiusToken(normalizedValue)) {
        return { valid: true, kind: 'token', normalizedValue };
    }
    if (isNumericUtilityLiteral(normalizedValue)) {
        return classifyNumericRadiusValue(normalizedValue);
    }
    if (isBareUtilityIdentifier(normalizedValue)) {
        if (!isCssWideKeyword(normalizedValue)) {
            return { valid: false, reason: 'unsupported_bare_identifier', normalizedValue };
        }
        return { valid: true, kind: 'keyword', normalizedValue };
    }
    return { valid: true, kind: 'arbitrary', normalizedValue };
}
//# sourceMappingURL=radius-values.js.map